import { useEffect, useState } from "react";

export default function ImageWithFallback({ image_url, fallback_url, alt="Image", image_style={ width: "100%", height: "auto"} }) {
  const [finalImageUrl, setFinalImageUrl] = useState('');

  useEffect(() => {

    checkIfImageExists(image_url, (exists) => {
      if (exists) {
        setFinalImageUrl(image_url);
      } else {
        setFinalImageUrl(fallback_url);
        console.error(`${image_url} - Image does not exist.`);
      }
    });
  }, [image_url]);

  return (
    <img
      src={finalImageUrl}
      alt={alt}
      style={image_style}
    />
  );
}

function checkIfImageExists(url, callback) {
  const img = new Image();
  img.src = url;

  if (img.complete) {
    callback(true);
  } else {
    img.onload = () => callback(true);
    img.onerror = () => callback(false);
  }
}
